
var sprite = require("/opt/build/repo/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol viewBox=\"0 0 16 13\" id=\"grid\" ><title>Asset 21</title><g data-name=\"Layer 2\"><path d=\"M0 0h4v3H0zM6 0h4v3H6zM12 0h4v3h-4zM0 5h4v3H0zM6 5h4v3H6zM12 5h4v3h-4zM0 10h4v3H0zM6 10h4v3H6zM12 10h4v3h-4z\"/></g></symbol>";
module.exports = sprite.add(image, "grid");


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/grid.svg
// module id = 656
// module chunks = 1474